



























































import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import VideoPlayer from "../components/video-player/video-player.vue";

export default Vue.extend({
  components: { VideoPlayer },
  data() {
    return {
      showVideoPlayer: false,
      videoUrl: "",
      support: {
        header: {
          title: "Welcome to GOATSUCCESS",
          icon: "support-icon-goat",
          description: "We're glad you're here! Watch this video for an overview of all the areas of GOATSUCCESS. Then check out the other video for more details.",
          video: "https://www.youtube.com/watch?v=C7ZbkbUpvJk&list=LLor3X-ag3IdpmRZByJZmOaw",
          videoTitle: "Watch the video 2:42",
        },
        groups: [
          {
            icon: "support-icon-teams",
            items: [
              {
                title: "What are Teams?",
                video: "https://www.youtube.com/watch?v=C7ZbkbUpvJk&list=LLor3X-ag3IdpmRZByJZmOaw",
                file: "",
              },
              {
                title: "Track team priorities.",
                video: "https://www.youtube.com/watch?v=C7ZbkbUpvJk&list=LLor3X-ag3IdpmRZByJZmOaw",
                file: "",
              },
              {
                title: "Conduct team conversations.",
                video: "https://www.youtube.com/watch?v=C7ZbkbUpvJk&list=LLor3X-ag3IdpmRZByJZmOaw",
                file: "",
              },
              {
                title: "Schedule team meetings.",
                video: "https://www.youtube.com/watch?v=C7ZbkbUpvJk&list=LLor3X-ag3IdpmRZByJZmOaw",
                file: "",
              },
              {
                title: "Share team files.",
                video: "https://www.youtube.com/watch?v=C7ZbkbUpvJk&list=LLor3X-ag3IdpmRZByJZmOaw",
                file: "",
              },
            ],
          },
          {
            icon: "support-icon-targets",
            items: [
              {
                title: "What are Targets?",
                video: "https://www.youtube.com/watch?v=C7ZbkbUpvJk&list=LLor3X-ag3IdpmRZByJZmOaw",
                file: "",
              },
              {
                title: "Share target objectives.",
                video: "https://www.youtube.com/watch?v=C7ZbkbUpvJk&list=LLor3X-ag3IdpmRZByJZmOaw",
                file: "",
              },
              {
                title: "Perform target check-ins.",
                video: "https://www.youtube.com/watch?v=C7ZbkbUpvJk&list=LLor3X-ag3IdpmRZByJZmOaw",
                file: "",
              },
              {
                title: "Measure target progress.",
                video: "https://www.youtube.com/watch?v=C7ZbkbUpvJk&list=LLor3X-ag3IdpmRZByJZmOaw",
                file: "",
              },
            ],
          },
          {
            icon: "support-icon-projects",
            items: [
              {
                title: "What are Projects?",
                video: "https://www.youtube.com/watch?v=C7ZbkbUpvJk&list=LLor3X-ag3IdpmRZByJZmOaw",
                file: "",
              },
              {
                title: "Track project list & tasks.",
                video: "https://www.youtube.com/watch?v=C7ZbkbUpvJk&list=LLor3X-ag3IdpmRZByJZmOaw",
                file: "",
              },
              {
                title: "See milestone calendar.",
                video: "https://www.youtube.com/watch?v=C7ZbkbUpvJk&list=LLor3X-ag3IdpmRZByJZmOaw",
                file: "",
              },
            ],
          },

          {
            icon: "support-icon-reviews",
            items: [
              {
                title: "What are Reviews?",
                video: "https://www.youtube.com/watch?v=C7ZbkbUpvJk&list=LLor3X-ag3IdpmRZByJZmOaw",
                file: "",
              },
              {
                title: "Share review objectives.",
                video: "https://www.youtube.com/watch?v=C7ZbkbUpvJk&list=LLor3X-ag3IdpmRZByJZmOaw",
                file: "",
              },
              {
                title: "Perform review check-ins.",
                video: "https://www.youtube.com/watch?v=C7ZbkbUpvJk&list=LLor3X-ag3IdpmRZByJZmOaw",
                file: "",
              },
              {
                title: "Measure review progress.",
                video: "https://www.youtube.com/watch?v=C7ZbkbUpvJk&list=LLor3X-ag3IdpmRZByJZmOaw",
                file: "",
              },
            ],
          },
          {
            icon: "support-icon-users",
            items: [
              {
                title: "What are Users?",
                video: "https://www.youtube.com/watch?v=C7ZbkbUpvJk&list=LLor3X-ag3IdpmRZByJZmOaw",
                file: "",
              },
              {
                title: "Invite and manage users.",
                video: "https://www.youtube.com/watch?v=C7ZbkbUpvJk&list=LLor3X-ag3IdpmRZByJZmOaw",
                file: "",
              },
              {
                title: "Track user priorities.",
                video: "https://www.youtube.com/watch?v=C7ZbkbUpvJk&list=LLor3X-ag3IdpmRZByJZmOaw",
                file: "",
              },
            ],
          },
          {
            icon: "support-icon-account",
            items: [
              {
                title: "What is your Account?",
                video: "https://www.youtube.com/watch?v=C7ZbkbUpvJk&list=LLor3X-ag3IdpmRZByJZmOaw",
                file: "",
              },
              {
                title: "Manage account settings.",
                video: "https://www.youtube.com/watch?v=C7ZbkbUpvJk&list=LLor3X-ag3IdpmRZByJZmOaw",
                file: "",
              },
              {
                title: "Manage subscription.",
                video: "https://www.youtube.com/watch?v=C7ZbkbUpvJk&list=LLor3X-ag3IdpmRZByJZmOaw",
                file: "",
              },
              {
                title: "See account invoices.",
                video: "https://www.youtube.com/watch?v=C7ZbkbUpvJk&list=LLor3X-ag3IdpmRZByJZmOaw",
                file: "",
              },
            ],
          },
        ],
      },
      userId: 1,
      name: "Test",
      email: "test@gmail.com",
      phone: 111-111-1111,
    };
  },
  computed: {
    ...mapState("session", ["user"]),
    ...mapState("billing", ["loading", "billingAccount"]),
  },
  created() {},
  mounted() {},
  watch: {
    user(newValue) {
      if (newValue) {
        (this as any).$intercom.boot({
          user_id: (this as any).user.id,
          user_hash: (this as any).user.intercomUserHash,
          name: (this as any).user.name,
          email: (this as any).user.emailAddress,
          phone: (this as any).user.phoneNumber,
        });
        (this as any).$intercom.show();
      }
    },
    email(email) {
      (this as any).$intercom.update({ email });
    },
  },
  methods: {
    handleVideoClick(url) {
      this.videoUrl = url;
      this.showVideoPlayer = true;
    },
  },
});
